module.exports = __webpack_public_path__ + "static/media/perinatal-disorders-icon.80555937.svg";